import { Box } from '@lifeomic/chroma-react/components/Box';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useExecutiveSummaryLocalAcceptedGeneration } from '../ExecutiveSummary/useExecutiveSummaryGeneration';

const useStyles = makeStyles(theme => ({
  loader: {
    width: theme.pxToRem(20),
  },
  loaderDotStyle: {
    fill: theme.palette.blue.main,
  },
}));

const messages = defineMessages({
  generating: {
    id: 'phc-web-toolkit.subjectViewer.actionPlan.generating',
    defaultMessage: 'Generating action plan drafts.',
  },
  generatingFromAnnualReport: {
    id: 'phc-web-toolkit.subjectViewer.actionPlan.generatingFromAnnualReport',
    defaultMessage: 'Generating… started from the Annual Report page.',
  },
});

export const ClinicalActionPlanGeneratingState = () => {
  const classes = useStyles({});
  const { formatMessage } = useIntl();
  const [localAcceptedTask] = useExecutiveSummaryLocalAcceptedGeneration();
  const fromAnnualReport = localAcceptedTask?.surface === 'annual_report';

  return (
    <Box
      data-testid="clinical-action-plan-generating"
      fullHeight
      fullWidth
      align="center"
      justify="center"
      gap={2}
      direction="column"
    >
      <DotLoader
        className={classes.loader}
        dotStyle={classes.loaderDotStyle}
        size={0}
      />
      <span>
        {formatMessage(
          fromAnnualReport
            ? messages.generatingFromAnnualReport
            : messages.generating,
        )}
      </span>
    </Box>
  );
};
